import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { CreditCard } from 'lucide-react';
import api, { errMsg } from '../lib/api';
import { Tgl } from './components';

export default function AdminStripe() {
  const [stripe, setStripe] = useState(null);
  const [env, setEnv] = useState(null);
  const [saving, setSaving] = useState(false);

  const load = async () => {
    try {
      const { data } = await api.get('/admin/settings/payments');
      setStripe({ enabled: false, ...(data.stripe || {}) });
      setEnv(data.stripe_env || null);
    } catch (e) { toast.error(errMsg(e)); }
  };
  useEffect(() => { load(); }, []);

  const save = async (enabled) => {
    setSaving(true);
    try {
      await api.put('/admin/settings/payments', { stripe: { enabled } });
      setStripe((s) => ({ ...s, enabled }));
      toast.success(enabled ? 'Card payments enabled at checkout' : 'Card payments disabled');
    } catch (e) { toast.error(errMsg(e)); } finally { setSaving(false); }
  };

  if (!stripe) return null;

  return (
    <div className="border hairline bg-white p-6 space-y-4 max-w-3xl mt-8" data-testid="stripe-settings">
      <div className="flex items-center justify-between">
        <div>
          <p className="font-display font-bold uppercase text-xl flex items-center gap-2"><CreditCard className="w-5 h-5" /> Stripe — Card Payments</p>
          <p className="text-[12px] text-[#575B60] mt-1">Secure card checkout via Stripe. Customers are redirected to Stripe to pay; orders are marked paid only after verified server-side confirmation (webhook + status check), never from the browser redirect alone.</p>
        </div>
        <span className={`font-mono2 text-[10px] uppercase tracking-widest border px-2.5 py-1 ${stripe.enabled ? 'border-[#6EE7B7] bg-[#ECFDF5] text-[#065F46]' : 'hairline text-[#8A8F95]'}`} data-testid="stripe-status">
          {stripe.enabled ? 'Enabled' : 'Disabled'}
        </span>
      </div>

      <div className="border hairline bg-[#F4F4F0] p-4 font-mono2 text-xs space-y-1.5">
        <p><span className="text-[#8A8F95]">MODE:</span> <span className="uppercase font-semibold" data-testid="stripe-mode">{env?.mode || 'not configured'}</span></p>
        <p><span className="text-[#8A8F95]">ACCOUNT:</span> {env?.account_id || '—'}</p>
        <p><span className="text-[#8A8F95]">PUBLISHABLE KEY:</span> {env?.publishable_key ? `${env.publishable_key.slice(0, 20)}…` : '—'}</p>
        <p><span className="text-[#8A8F95]">WEBHOOK:</span> {env?.webhook_path} (registered automatically)</p>
        <p><span className="text-[#8A8F95]">SECRET KEY:</span> stored server-side only, never exposed</p>
      </div>

      <Tgl label="Enable card payments at checkout" checked={!!stripe.enabled} onChange={save} testid="stripe-enabled" />
      {saving && <p className="font-mono2 text-[10px] uppercase tracking-widest text-[#8A8F95]">Saving…</p>}

      <p className="text-[11px] text-[#8A8F95] leading-relaxed">
        Test mode: use card 4242 4242 4242 4242 with any future expiry and any CVC. Refunds for Stripe payments
        can be issued from Admin → Payments → Review → Refund.
      </p>
    </div>
  );
}
